import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common'

import * as numeral from 'numeral';

/**
 * Generated class for the PricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'price',
})
export class PricePipe extends DecimalPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    let result;
    let magnitude = '';
    let format = '';

    let symbol: string;
    let longForm: boolean = true;

    if(args){
      if(args.length == 2){
        symbol = args[0];
        longForm = args[1];
      }else if(args.length == 1){
        symbol = args[0];
      }
    }

    if(value >= 1000000000000){
      magnitude = (longForm ? 'Trillion':'T');
      value = value / 1000000000000;
      format = '1.0-2';
    }else if(value >= 1000000000){
      magnitude = (longForm ? 'Billion':'B');
      value = value / 1000000000;
      format = '1.0-2';
    }else if(value >= 1000000){
      magnitude = (longForm ? 'Million':'MM');
      value = value / 1000000;
      format = '1.0-2';
    }else if(value >= 1){
      format = '1.2-2';
    }else{
      format = '0.0-5';
    }

    result = super.transform(value, format);
    if(magnitude){
      result = `${result} ${magnitude}`;
    }

    if(symbol && symbol != 'sat '){
      result = `${symbol}${result}`;
    }

    return result;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/price/price.ts